// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

export const useBasicAuth = () => {
  const getBasicAuth = (_credentials: string): Promise<void> => rejectServiceClosed();

  return { getBasicAuth };
};
